import { render } from "./Units.vue?vue&type=template&id=1abea8fa&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"

import "./Units.vue?vue&type=style&index=0&id=1abea8fa&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abea8fa"]])

export default __exports__